import { isReadingPanePositionBottom, isReadingPanePositionOff } from './readingPanePosition';
import { ListViewLayout } from '../store/schema/MailLayoutStore';
import { getStore } from '../store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';

/**
 * Returns a flag indicating whether the list view should show items in a single line.
 * If the clientListViewLayout is set to a non null value we use it to determine the list view layout else
 *
 * This returns true if reading pane setting is hidden or off client side, but
 * the actual persisted setting is not RIGHT. If the actual setting is RIGHT and the client
 * side setting is OFF it means that we have overridden the RIGHT setting in which case we
 * still want to show list view items in 3 line and not single line
 */
export function isSingleLineListView(): boolean {
    const clientListViewLayout = getClientListViewLayout();
    if (clientListViewLayout !== null) {
        return clientListViewLayout == ListViewLayout.SingleLine;
    }

    return (
        (isReadingPanePositionBottom() || isReadingPanePositionOff()) &&
        getUserConfiguration().UserOptions.GlobalReadingPanePositionReact !=
            ReadingPanePosition.Right
    );
}

/**
 * Returns the listViewLayout as per clients current browser window bucket.
 * This layout will override the user's list view layout set for current configuration
 */
function getClientListViewLayout(): ListViewLayout {
    switch (getStore().browserWidthBucket) {
        case BrowserWidthBucket.From418_Below:
        case BrowserWidthBucket.From419_To554:
            return ListViewLayout.ThreeLine;
        case BrowserWidthBucket.From555_To768:
        case BrowserWidthBucket.From769_To918:
        case BrowserWidthBucket.From919_To999:
        case BrowserWidthBucket.From1000_To1199:
        case BrowserWidthBucket.From1200_To1399:
        case BrowserWidthBucket.From1400_To1599:
        case BrowserWidthBucket.From1600_Above:
        default:
            return null;
    }
}
